import React from 'react'
import PropTypes from 'prop-types'
import { GradeListWrapper, StyledGradeProgressData } from './component.styles'

const AdminGradeList = ({ bhuStatus, grades, siteId }) => {
  return (
    <GradeListWrapper bhuStatus={bhuStatus}>
      {grades?.map(grade => {
        const {
          classesNotStarted,
          lessonsCompleted,
          name,
          numOfClasses,
          totalLessons,
        } = grade
        return (
          <StyledGradeProgressData
            bhuStatus={bhuStatus}
            classesNotStarted={classesNotStarted}
            grade={name}
            key={`grade-${name}-progress`}
            lessonsCompleted={lessonsCompleted}
            numOfClasses={numOfClasses}
            siteId={siteId}
            totalLessons={totalLessons}
          />
        )
      })}
    </GradeListWrapper>
  )
}

AdminGradeList.propTypes = {
  bhuStatus: PropTypes.bool,
  grades: PropTypes.array,
  siteId: PropTypes.number,
}

export default AdminGradeList
